import { render, staticRenderFns } from "./UserMiniProfile.vue?vue&type=template&id=40f1108b&scoped=true&"
import script from "./UserMiniProfile.vue?vue&type=script&lang=js&"
export * from "./UserMiniProfile.vue?vue&type=script&lang=js&"
import style0 from "./UserMiniProfile.vue?vue&type=style&index=0&id=40f1108b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f1108b",
  null
  
)

export default component.exports